module.exports = __webpack_public_path__ + "static/media/06GalleryPuppets.ccc945d2.jpeg";